import { getSecureAccountsApi, postSecureAccountsApi, putAccountsApi, putS3Data, deleteAccountsApi, postAccountsApi, postSecureMfaApi, putSecureMfaApi } from "@Shared/utils/ajax";
export const getAccountDetails = async () => {
  return getSecureAccountsApi({}, "");
};
export const getNotificationPreferences = () => {
  const endpoint = "/notification/preferences";
  return getSecureAccountsApi({}, endpoint);
};
export const updateNotificationPreferences = preferences => {
  const endpoint = "/notification/preferences";
  return putAccountsApi(preferences, endpoint);
};
export const updateAccountPreferences = preferences => {
  const endpoint = "/preferences";
  return putAccountsApi(preferences, endpoint);
};
export const updatePersonalDetails = async details => {
  return putAccountsApi(details, "");
};
export const getEmailSignature = async () => {
  const endpoint = "/email/signature";
  return getSecureAccountsApi({}, endpoint);
};
export const updateEmailSignature = async emailSignature => {
  const endpoint = "/email/signature";
  return putAccountsApi({
    emailSignature
  }, endpoint);
};
export const updateDomain = async subdomain => {
  const endpoint = "/customize/subdomain";
  return putAccountsApi({
    subdomain
  }, endpoint);
};
export const uploadToS3 = async (file, endpoint, contentType = "") => {
  return await putS3Data(file, endpoint, contentType);
};
export const setProfilePhoto = async () => {
  const endpoint = "/profile-photo";
  return postSecureAccountsApi({}, endpoint);
};
export const getPhotoSignedURL = async fileName => {
  const endpoint = "/profile-photo/signed-s3-url";
  return getSecureAccountsApi({
    fileName
  }, endpoint);
};
export const removeProfilePhoto = async () => {
  const endpoint = "/profile-photo";
  return deleteAccountsApi(endpoint);
};
export const getAccountType = async ({
  email,
  type
}) => {
  const endpoint = `/validate/email`;
  return postSecureAccountsApi({
    email,
    type
  }, endpoint);
};
export const createAccount = async accountDetails => {
  return postAccountsApi(accountDetails, "");
};
export const verifyAccountEmail = async (email, confirmationCode) => {
  return postAccountsApi({
    email,
    confirmationCode
  }, "/verify-account");
};
export const resendConfirmationCode = async email => {
  return postAccountsApi({
    email
  }, "/resend-confirmation-code");
};
export const login = async (email, password, currentSubdomain = "", deviceConfig) => {
  return postAccountsApi({
    email,
    password,
    currentSubdomain,
    deviceConfig
  }, "/login");
};
export const logout = async token => {
  return postAccountsApi({
    token
  }, "/logout");
};
export const validateMfa = async ({
  mfaCode,
  session,
  userId,
  isTrustedDevice,
  mfaMethod
}) => {
  return postAccountsApi({
    mfaCode,
    session,
    userId,
    isTrustedDevice,
    mfaMethod
  }, `/${userId}/mfa-validate`);
};
export const validateToken = async token => {
  return postAccountsApi({
    token
  }, "/validate-token");
};
export const confirmSelectedMfaAndSendCode = async (token, mfaValue, username, mfaMethod) => {
  const endpoint = "/mfa-select-method";
  return postSecureMfaApi({
    token,
    mfaValue,
    username,
    mfaMethod
  }, endpoint);
};
export const enableMfa = async mfaInput => {
  const endpoint = `/mfa-enable`;
  return postSecureMfaApi(mfaInput, endpoint);
};
export const snoozeMfaForLater = async (token, mfaPreferences, username) => {
  const endpoint = `/mfa-snooze/`;
  return await putSecureMfaApi({
    token,
    mfaPreferences,
    username
  }, endpoint);
};
export const resendMfaCode = async body => {
  const endpoint = `/resend-mfa-code/`;
  return await postAccountsApi(body, endpoint);
};